// GAVION (quality pass): route-level code splitting for the pages mounted in CRM.tsx. Each page keeps
// its name, so CRM.tsx only swaps its import source.
import { lazyNamed } from "./lazyNamed";

export const UsersSettings = lazyNamed(
  () => import("../settings/users/UsersSettings"),
  "UsersSettings",
);
export const IntegrationsSettingsPage = lazyNamed(
  () => import("../settings/integrations/IntegrationsSettingsPage"),
  "IntegrationsSettingsPage",
);
export const MeetingsPage = lazyNamed(
  () => import("../meetings/MeetingsPage"),
  "MeetingsPage",
);
export const DialerRoute = lazyNamed(
  () => import("../dialer/screen/DialerPage"),
  "DialerRoute",
);
export const TodoListPage = lazyNamed(
  () => import("../dialer/todo/TodoListPage"),
  "TodoListPage",
);
// GAVION my-calls: « Mes appels » (call history)
export const MyCallsPage = lazyNamed(
  () => import("../dialer/history/MyCallsPage"),
  "MyCallsPage",
);
// GAVION inbound calls: « Appel entrant » (#/appel-entrant, opened by MicroSIP)
export const InboundCallPage = lazyNamed(
  () => import("../dialer/inbound/InboundCallPage"),
  "InboundCallPage",
);
export const SoftphoneSetupPage = lazyNamed(
  () => import("../settings/telephone/SoftphoneSetupPage"),
  "SoftphoneSetupPage",
);
export const CallSettingsPage = lazyNamed(
  () => import("../settings/calls/CallSettingsPage"),
  "CallSettingsPage",
);
export const EmailSettingsPage = lazyNamed(
  () => import("../settings/email/EmailSettingsPage"),
  "EmailSettingsPage",
);
export const GoalsSettingsPage = lazyNamed(
  () => import("../settings/goals/GoalsSettingsPage"),
  "GoalsSettingsPage",
);
// GAVION rep stats: Paramètres → Coûts (admins)
export const CostsSettingsPage = lazyNamed(
  () => import("../settings/costs/CostsSettingsPage"),
  "CostsSettingsPage",
);
// GAVION recruiting: « Recrutement » (admins)
export const RecruitingPage = lazyNamed(
  () => import("../recruiting/RecruitingPage"),
  "RecruitingPage",
);
export const DataQualityPage = lazyNamed(
  () => import("../dataQuality/DataQualityPage"),
  "DataQualityPage",
);
export const SystemHealthPage = lazyNamed(
  () => import("../settings/health/SystemHealthPage"),
  "SystemHealthPage",
);
export const PrivacySettingsPage = lazyNamed(
  () => import("../privacy/PrivacySettingsPage"),
  "PrivacySettingsPage",
);
// GAVION booking: Paramètres → Mon calendrier de démo
export const BookingSettingsPage = lazyNamed(
  () => import("../settings/booking/BookingSettingsPage"),
  "BookingSettingsPage",
);

// GAVION ai-email: proposed drafts to approve
export const DraftsPage = lazyNamed(
  () => import("../ai/drafts/DraftsPage"),
  "DraftsPage",
);

// Upstream dashboards: only used when no `dashboard` prop is given (the Gavion app passes
// GavionDashboard), so their chart library (@nivo) no longer ships in the main chunk.
export const Dashboard = lazyNamed(
  () => import("../../atomic-crm/dashboard/Dashboard"),
  "Dashboard",
);
export const MobileDashboard = lazyNamed(
  () => import("../../atomic-crm/dashboard/MobileDashboard"),
  "MobileDashboard",
);

// Leads resource (list and lead page).
export const LeadListPage = lazyNamed(
  () => import("../leads/LeadsResource"),
  "LeadListPage",
);
export const LeadShow = lazyNamed(
  () => import("../leads/LeadsResource"),
  "LeadShow",
);
// GAVION ai-email: Paramètres → IA
export const AiSettingsPage = lazyNamed(
  () => import("../settings/ai/AiSettingsPage"),
  "AiSettingsPage",
);
// GAVION custom pipeline: Paramètres → Pipeline (admins)
export const PipelineSettingsPage = lazyNamed(
  () => import("../settings/pipeline/PipelineSettingsPage"),
  "PipelineSettingsPage",
);
// GAVION lead statuses: Paramètres → Statuts des leads (admins)
export const LeadStatusesSettingsPage = lazyNamed(
  () => import("../settings/leadStatuses/LeadStatusesSettingsPage"),
  "LeadStatusesSettingsPage",
);

// GAVION commissions: Paramètres → Forfaits, Plans de commission (admins)
export const PackagesSettingsPage = lazyNamed(
  () => import("../commissions/settings/PackagesSettingsPage"),
  "PackagesSettingsPage",
);
export const CommissionPlansSettingsPage = lazyNamed(
  () => import("../commissions/settings/CommissionPlansSettingsPage"),
  "CommissionPlansSettingsPage",
);
